<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="page-article-section">
    <div class="recommend-article">
      <div class="recommend-article-container">
        <div
          v-if="isMobile"
          class="slider-container"
        >
          <div
            v-if="!$fetchState.pending && !isLoading"
            ref="articleSwiper"
            v-swiper:articleSwiper="silderOptions"
            class="swiper"
            @slideChange="slideChangeHandler"
            @click="clickSlideHandler"
          >
            <div class="swiper-wrapper">
              <div
                v-for="bannerArticle in bannerArticleList.data"
                :key="bannerArticle.Id"
                class="swiper-slide"
              >
                <ArticleCard
                  :aspect-ratio="imageAspectRatio"
                  :content="bannerArticle"
                  display="column"
                  :show-content="true"
                  :show-title-on-img="isMobile"
                  :show-title="false"
                />
              </div>
            </div>
            <div class="swiper-pagination swiper-pagination-bullets" />
          </div>
          <v-skeleton-loader
            v-else
            type="image, article"
          />
        </div>
        <template v-else>
          <div class="recommend-article-container--left">
            <v-skeleton-loader
              v-if="$fetchState.pending"
              width="450px"
              type="image, article"
            />
            <ArticleCard
              v-else-if="bannerArticleList.data.length"
              :content="bannerArticleList.data[0]"
              display="column"
              img-width="450px"
              img-height="216px"
              :show-title-on-img="isMobile"
              @click.native="goArticlePage(bannerArticleList.data[0], 'banner')"
            />
          </div>
          <div class="recommend-article-container--right">
            <template v-if="$fetchState.pending">
              <v-skeleton-loader
                v-for="x in 3"
                :key="x"
                type="list-item-avatar-three-line"
              />
            </template>
            <template v-else-if="bannerArticleList.data.slice(1, 4).length">
              <ArticleCard
                v-for="bannerArticle in bannerArticleList.data.slice(1, 4)"
                :key="`${ 'banner' + bannerArticle.Id}`"
                :img-width="isMobile ? '' : '200px'"
                :img-height="isMobile ? '' : '96px'"
                :aspect-ratio="isMobile ? imageAspectRatio : 0"
                :content="bannerArticle"
                display="row"
                :show-content="false"
                :show-title-on-img="isMobile"
                @click.native="goArticlePage(bannerArticle, 'banner')"
              />
            </template>
          </div>
        </template>
      </div>
    </div>
    <div
      v-if="fetchAllDone && bannerArticleList.data.length"
      class="article-section-spacer"
    />
    <template v-if="fetchAllDone">
      <div class="top-article">
        <div class="top-article-container__title">
          <div class="top-article-container__title__line--left" />
          <h2 class="top-article-container__title__text">
            精選文章
          </h2>
          <div class="top-article-container__title__line--right" />
        </div>
        <div class="top-article-select-filter">
          <v-select
            v-model="articleList.sortType"
            :items="sortTypeList"
            placeholder="請選擇排序方式"
            item-text="name"
            item-value="id"
            outlined
            return-object
            hide-details
            @change="changeSortHandler"
          >
            <template #append>
              <i class="icon icon-chevron-down primary-icon" />
            </template>
          </v-select>
        </div>
        <div class="top-article-container">
          <div class="top-article-container--left">
            <template v-if="articleList.data.length">
              <ArticleCard
                v-for="article in articleList.data"
                :key="`${'top-article' + article.Id}`"
                class="top-article-container__article"
                :content="article"
                :display="isMobile ? 'column' : 'row'"
                :img-width="isMobile ? '' : '250px'"
                :img-height="isMobile ? '' : '120px'"
                :aspect-ratio="isMobile ? imageAspectRatio : 0"
                :show-content="false"
                :show-title-on-img="false"
                @click.native="goArticlePage(article)"
              />
            </template>
            <div
              v-if="articleList.loading"
              class="loading"
            >
              <v-skeleton-loader
                type="article"
              />
            </div>
          </div>
          <div
            v-if="showMoreArticleSection"
            class="article-section-spacer hidden-lg"
          />
          <div
            v-if="showMoreArticleSection"
            class="top-article-container--right"
          >
            <div class="top-article-container__more-article__title">
              <div class="top-article-container__more-article__title__line--left" />
              <h2 class="top-article-container__more-article__title__text">
                更多文章
              </h2>
              <div class="top-article-container__more-article__title__line--right" />
            </div>
            <div
              v-for="(moreArticle, i) in randomArticleList.data"
              :key="moreArticle.Id"
              class="top-article-container__more-article__content"
            >
              <div class="top-article-container__more-article__content__number-wrapper">
                <div
                  class="top-article-container__more-article__content__number"
                >
                  <span>{{ i + 1 }}</span>
                </div>
              </div>
              <div
                class="top-article-container__more-article__content__text"
                @click="goArticlePage(moreArticle, 'moreArticle')"
              >
                {{ moreArticle.Title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div
      v-else
      class="loading"
    >
      <v-skeleton-loader
        type="article"
      />
    </div>
  </div>
</template>

<script>
import defaultArticleImg from '@/assets/image/article/default-cover.png'
import { mapGetters } from 'vuex'
import ArticleCard from '@/components/PageComponent/ArticleSection/ArticleCard'
export default {
  components: {
    ArticleCard
  },
  async asyncData ({ route, env, store }) {
    return {
      routeFullPath: route.fullPath,
      webBaseUrl: String(env.BASE_WEB_URL || ' ').slice(0, -1)
    }
  },
  data () {
    return {
      isLoading: true,
      title: '生活情報站',
      description: '全台社區一致推薦！智生活經營社區超過25年，給你最便利與實用的生活資訊，最全面的便利生活服務！任何疑難雜症都在智樂家一一為您解答。',
      image: '',
      imageAspectRatio: 25 / 12,
      silderOptions: {
        loop: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      isLoadingMore: false,
      sortTypeList: [
        {
          id: 1,
          name: '上架新 ➝ 舊'
        },
        {
          id: 2,
          name: '瀏覽數高 ➝ 低'
        }
      ],
      // 輪播文章
      bannerArticleList: {
        offset: 0,
        count: 10,
        data: []
      },
      // 精選文章
      articleList: {
        loading: false,
        offset: 0,
        count: 10,
        sortType: {
          id: 1
        },
        sortId: 1,
        total: 0,
        excludeArticleIds: [],
        data: []
      },
      // 精選文章快取
      cacheArticleList: {},
      // 更多文章
      randomArticleList: {
        IfLessThenReturnEmpty: 15,
        WithOutTheTop: 5,
        Count: 5,
        data: []
      },
      // 文章取值主分類id
      aritcleMainTypeIds: [39, 69],
      lastArticleObserver: null
    }
  },
  async fetch () {
    try {
      this.$nuxt?.$loading?.start()
      await Promise.all([
        this.getArticleBannerList(),
        this.getRandomArticleList()
      ])
      await this.getArticleList(true)
      this.image = this.bannerArticleList.data.find(bannerArticle => bannerArticle.CoverPictureUrl)?.CoverPictureUrl || this.$nuxt.context.env.BASE_WEB_URL.slice(0, -1) + defaultArticleImg
      this.$nuxt?.$loading?.finish()
    } catch (err) {
      console.log('err', err)
      this.$nuxt?.$loading?.finish()
    }
  },
  head () {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title + this.$store.state.meta.titleTemple },
        { hid: 'description', name: 'description', content: this.description },
        { hid: 'og:url', property: 'og:url', content: this.webBaseUrl + this.routeFullPath },
        { hid: 'og:title', property: 'og:title', content: this.title + this.$store.state.meta.titleTemple },
        { hid: 'og:description', property: 'og:description', content: this.description },
        { hid: 'og:image', property: 'og:image', content: this.image },
        { hid: 'twitter:url', property: 'twitter:url', content: this.webBaseUrl + this.routeFullPath },
        { hid: 'twitter:title', property: 'twitter:title', content: this.title + this.$store.state.meta.titleTemple },
        { hid: 'twitter:description', property: 'twitter:description', content: this.description },
        { hid: 'twitter:image', property: 'twitter:image', content: this.image }
      ]
    }
  },
  jsonld () {
    const baseUrl = String(this.$nuxt.context.env.BASE_WEB_URL || ' ').slice(0, -1)
    const homePageRouteData = this.$nuxt.$router.resolve({
      name: 'home'
    })
    const homePageUrl = baseUrl + homePageRouteData.resolved.fullPath
    const listPageRouteData = this.$nuxt.$router.resolve({
      name: 'informationStation'
    })
    const listPageUrl = baseUrl + listPageRouteData.resolved.fullPath
    const getBreadcrumbList = () => {
      return [
        {
          '@type': 'ListItem',
          position: 1,
          name: '智樂家',
          item: homePageUrl
        }, {
          '@type': 'ListItem',
          position: 2,
          name: '生活情報站',
          item: listPageUrl
        }
      ]
    }
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: getBreadcrumbList()
    }
  },
  mounted () { // 使用getters裡的會有延遲問題造成跑版，暫時先使用此解法
    this.$store.commit('setWindowWidth', window.innerWidth)
    this.isLoading = false
  },
  computed: {
    ...mapGetters([
      'isMobile'
    ]),
    showMoreArticleSection () { // 手機尺寸需等精選文章載完才能顯示更多文章區塊
      return this.randomArticleList.data.length &&
        (!this.isMobile || (!this.hasMoreArticleToLoad &&
        !this.articleList.loading))
    },
    hasMoreArticleToLoad () {
      return this.articleList.offset <= this.articleList.total
    },
    fetchAllDone () {
      return !this.isLoading && !this.$fetchState.pending
    }
  },
  watch: {
    fetchAllDone (val) {
      if (val) {
        this.$nextTick(() => {
          this.lastArticleCardObserve()
        })
      }
    }
  },
  beforeDestroy () {
    this.lastArticleObserver?.disconnect()
  },
  methods: {
    slideChangeHandler () {
      const { isBeginning, isEnd } = this.$refs.articleSwiper.swiper
      if (isBeginning || isEnd) {
        this.$refs.articleSwiper.swiper.loopDestroy()
        this.$refs.articleSwiper.swiper.loopCreate()
      }
    },
    clickSlideHandler () {
      let index = this.$refs.articleSwiper.swiper.realIndex
      // swiper的bug,loop模式下index重新loop到第一張的時候會取到copy的slide index，因此需要自行重新歸0
      if (index > this.bannerArticleList.data.length - 1) index = 0
      this.goArticlePage(this.bannerArticleList.data[index], 'banner')
    },
    // api
    async getArticleBannerList () {
      try {
        const postData = {
          MainTypeIds: this.aritcleMainTypeIds,
          'PagingSetting.Offset': this.bannerArticleList.offset,
          'PagingSetting.Count': this.bannerArticleList.count
        }
        const response = await this.$axios.get('api/v1/Article/Banner', { params: postData, useCache: true })
        this.bannerArticleList.data = this.formatArticleData(response.data.Data.Articles).slice(0, 4)
        this.bannerArticleList.data.forEach((article, index) => {
          this.articleList.excludeArticleIds.push(article.Id)
        })
      } catch (err) {
        console.log('err', err)
        return Promise.reject(err)
      }
    },
    async getArticleList (filterArticle = false) {
      if (!this.hasMoreArticleToLoad) return
      if (this.articleList.loading) return
      try {
        this.articleList.loading = true
        const postData = {
          MainTypeIds: this.aritcleMainTypeIds,
          SortBy: this.articleList.sortType.id,
          ExcludeArticleIds: [],
          'PagingSetting.Offset': this.articleList.offset,
          'PagingSetting.Count': this.articleList.count
        }
        const response = await this.$axios.get('api/v1/Article', { params: postData, useCache: true })
        this.articleList.data = [
          ...this.articleList.data,
          ...this.formatArticleData(response.data.Data.Articles)
        ]
        if (filterArticle) {
          this.articleList.data = this.filterArticleHandler(this.articleList.data)
        }
        this.articleList.total = response.data.Data.Total
        this.articleList.offset = this.articleList.offset += this.articleList.count
        this.articleList.loading = false
      } catch (err) {
        this.articleList.loading = false
        console.log('err', err)
        return Promise.reject(err)
      }
    },
    async getRandomArticleList () {
      try {
        const {
          IfLessThenReturnEmpty,
          WithOutTheTop,
          Count
        } = this.randomArticleList
        const postData = {
          MainTypeId: this.aritcleMainTypeIds,
          IfLessThenReturnEmpty,
          WithOutTheTop,
          Count
        }
        const response = await this.$axios.get('api/v1/Article/Random', { params: postData, useCache: true })
        this.randomArticleList.data = this.formatArticleData(response.data.Data.Articles)
        this.randomArticleList.data.forEach(a => {
          this.articleList.excludeArticleIds.push(a.Id)
        })
      } catch (err) {
        console.log('err', err)
        return Promise.reject(err)
      }
    },
    async changeSortHandler () {
      try {
        this.$gaLogEvent('文章專區', `文章排序_${this.articleList.sortType.id === 1 ? '上架' : '瀏覽'}`)
        // 寫入快取
        if (!this.cacheArticleList[this.articleList.sortId]) this.cacheArticleList[this.articleList.sortId] = {}
        const sortData = this.sortTypeList.find(sort => sort.id === this.articleList.sortId)
        this.cacheArticleList[sortData.id] = { ...this.articleList, sortType: sortData }
        this.articleList.sortId = this.articleList.sortType.id
        // 若有快取就直接拿
        if (this.cacheArticleList[this.articleList.sortId]) {
          this.articleList = this.cacheArticleList[this.articleList.sortId]
        } else {
          this.articleList.offset = 0
          this.articleList.total = 0
          this.articleList.data = []
          await this.getArticleList(true)
          if (this.articleList.data.length < 5) await this.getArticleList(true)
        }
        this.$nextTick(() => {
          if (this.hasMoreArticleToLoad) {
            this.lastArticleObserver?.disconnect()
            this.lastArticleCardObserve()
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async loadMoreContent () {
      if (this.isLoadingMore) return
      try {
        this.isLoadingMore = true
        let filterArticle = false
        if (this.articleList.data.length < 5) filterArticle = true
        await this.getArticleList(filterArticle)
        setTimeout(() => {
          this.isLoadingMore = false
        }, 1500)
      } catch (err) {
        console.log('err', err)
      }
    },
    filterArticleHandler (articleData) {
      let filteredCounts = 0
      let filterArticleData = []
      if (articleData.length > 5) {
        filterArticleData = articleData.filter((article, index) => {
          if (index - filteredCounts + 1 > 5) { // 第五篇後的不管
            return true
          }
          if (this.articleList.excludeArticleIds.includes(article.Id)) {
            filteredCounts++
            return false
          } else return true
        })
      }
      return filterArticleData
    },
    formatArticleData (articleData) {
      return articleData.map(data => {
        data.CreateTime = this.$dayjs(data.CreateAt).format('YYYY/MM/DD')
        if (!data.CoverPictureUrl) {
          data.CoverPictureUrl = require('@/assets/image/article/default-cover.png')
        }
        return data
      })
    },
    lastArticleCardObserve () {
      this.lastArticleObserver = new IntersectionObserver(async (entry) => {
        const lastArticle = entry[0]
        if (!lastArticle.isIntersecting) return
        await this.loadMoreContent()
        this.lastArticleObserver.unobserve(lastArticle.target)
        if (!this.hasMoreArticleToLoad) return // 已載完所有文章
        this.lastArticleObserver.observe(document.querySelector('.top-article-container__article:last-child'))
      })
      const lastArticle = document.querySelector('.top-article-container__article:last-child')
      if (!lastArticle) return
      this.lastArticleObserver.observe(lastArticle)
    },
    goArticlePage (article, type) {
      switch (type) {
        case 'banner':
          this.$gaLogEvent('文章專區', `推薦文章_${article.Title}_${article.Id}`)
          break
        case 'moreArticle':
          this.$gaLogEvent('文章專區', '更多文章')
          break
        default:
          break
      }
      this.$nuxt.$router.push({ name: 'informationStation-article-idsn', params: { idsn: article.Id, toTop: true } })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-article-section {
  max-width: 75rem;
  margin: 3rem auto;
  padding: 0px 1rem;
}
.recommend-article {
  &-container {
    $leftWidth: 450px;
    display: flex;
    &--left {
      width: $leftWidth;
      margin-right: 5rem;
    }
    &--right {
      display: flex;
      flex-direction: column;
      width: calc(100% - #{$leftWidth} - 2.5rem);
      .article-card__container {
        padding-bottom: 24px;
        +.article-card__container {
          padding-top: 24px;
          border-top: 1px solid $color-border-primary;
        }
      }
    }
  }
}

.top-article {
  &-container {
    display: flex;
    &--left {
      width: 65%;
      margin-right: 5rem;
    }
    &--right {
      width: calc(35% - 20px);
      max-width: 330px;
    }
    &__title {
      width: 50rem;
      margin-bottom: 20px;
      @include line-through-title(21px, $color-text-primary, $color-background-primary, 2px);
    }
    &__article {
      padding-top: 20px;
      padding-bottom: 20px;
      +.top-article-container__article {
        border-top: 1px solid $color-border-primary;
      }
    }
    &__more-article {
      &__title {
        width: 300px;
        margin-bottom: 20px;
        @include line-through-title(21px, #ff783f, #ff783f, 2px);
      }
      &__content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 0 10px 20px;
        +.top-article-container__more-article__content {
          .top-article-container__more-article__content__text {
            padding-top: 20px;
            border-top: 1px solid $color-border-primary;
            width: 100%;
          }
          .top-article-container__more-article__content__number-wrapper {
            padding-top: 20px;
          }
        }
        &__number {
          padding: 10px;
          background-color: #ff783f;
          border-radius: 50%;
          width: 28px;
          height: 28px;
          color: #ffffff;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 12px;
        }
        &__text {
          font-weight: bold;
          text-align: left;
          cursor: pointer;
        }
      }
    }
  }
  &-select-filter {
    width: 180px;
    margin: 10px 0;
    $selectInputHeight: 44px;
    ::v-deep {
      .v-input__slot {
        min-height: $selectInputHeight;
      }
      .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
        color: $color-background-primary;
      }
      .theme--light.v-select .v-select__selection--comma {
        color: $color-text-primary;
        font-weight: 600;
        font-size: 15px;
      }
      .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
        padding: 6px 0;
      }
      .v-text-field--enclosed .v-input__append-inner {
        margin: auto;
        .v-input__icon {
          height: $selectInputHeight;
        }
      }
      .v-input__append-inner {
        padding: 6px 0;
        .primary-icon {
          color: $color-primary;
          font-size: 24px;
          height: 24px;
          vertical-align: middle;
          &::before {
            vertical-align: baseline;
          }
        }
      }
    }
  }
}

.article-section-spacer {
  width: 100vw;
  height: 8px;
  background-color: #efeff4;
  margin: 40px calc(1em - 100%); /* old browsers fallback */
  margin: 40px calc(50% - 50vw);
  &.hidden-lg {
    display: none;
  }
}

.slider-container {
  display: none;
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  ::v-deep {
    $controlsMargin: 40px;
    .slider-container {
      width: 100%;
      display: block;
    }
    .swiper-container {
      padding-bottom: $controlsMargin;
    }
    .swiper-wrapper {
      align-items: stretch;
    }
    .swiper-slide {
      height: initial;
      .article-card__container {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
    .swiper-container-horizontal > .swiper-pagination {
      position: absolute;
      bottom: 0;
    }
    .swiper-container-horizontal > .swiper-pagination {
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        &-active {
          background: $color-primary;
        }
      }
    }
  }
  .top-article {
    &-container {
      flex-direction: column;
      &--left {
        width: 100%;
        margin-right: 0px;
      }
      &--right {
        width: 100%;
        max-width: unset;
      }
      &__article {
        padding-bottom: 20px;
      }
      &__title {
        width: 100%;
      }
      &__more-article {
        &__title {
          width: 100%;
          margin-bottom: 24px;
        }
        &__content {
          display: flex;
          align-items: center;
          padding-bottom: 20px;
          +.top-article-container__more-article__content {
            .top-article-container__more-article__text {
              border-top: 1px solid $color-border-primary;
            }
          }
          &__number {
            padding: 10px;
            background-color: #ff783f;
            border-radius: 50%;
            width: 28px;
            height: 28px;
            color: #ffffff;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 12px;
          }
          &__text {
            font-weight: bold;
          }
        }
      }
    }
  }
  .article-section-spacer {
    margin: 20px calc(1em - 100%) 32px; /* old browsers fallback */
    margin: 20px calc(50% - 50vw) 32px;
    &.hidden-lg {
      display: block;
    }
  }
}
</style>
